const firebaseConfig = {
    apiKey: "AIzaSyDdMXlQni4PBlorMjmq8yVJan80TL3raY0",
    authDomain: "kids-health-care.firebaseapp.com",
    projectId: "kids-health-care",
    storageBucket: "kids-health-care.appspot.com",
    messagingSenderId: "229707147118",
    appId: "1:229707147118:web:801ded7475ed195830837f"
  };
  export default firebaseConfig;